import _ from 'lodash';
import {fork, all} from 'redux-saga/effects';

import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

import {reducer as formReducer} from 'redux-form';

import {default as authReducer, LOGOUT_REQUEST} from './auth';
import {
  loginFlow,
  userProfileRequestSaga,
  forceInactivityLogoutFlow
} from './auth';

import {
  default as locationsReducer,
  locationDetailSaga,
  locationListSaga
} from './locations';

import {
  default as bookingsReducer,
  fetchBookingsSaga,
  bookingDetailSaga,
  fetchBookingsForBookingTrackerSaga
} from './bookings';
import {default as tenancyReducer, tenancyDetailSaga} from './tenancy';
import {default as allocationsReducer, allocationsSaga} from './allocations';
import {default as filesReducer, filesSaga} from './files';
import {default as modalsReducer, modalsSaga} from './modals';
import {default as roomsReducer, roomsSaga} from './rooms';
import {default as paymentsReducer, paymentsSaga} from './payments';
import {default as countriesReducer, countriesSaga} from './countries';
import {agreementUsersSaga} from './agreementUsers';
import {default as frontDeskReducer, frontDeskSaga} from './frontDesk';
import {default as statusPageReducer, statusPageSaga} from './statusPage';
import {default as teamsReducer, teamsListSaga, teamsDetailSaga} from './teams';
import {default as usersReducer, userListSaga, userDetailSaga} from './users';
import {default as notesReducer, notesSaga} from './notes';
import {default as webhooksReducer, webhooksSaga} from './webhooks';
import {default as quickSearchReducer, quickSearchSaga} from './quicksearch';
import {default as occupancyReducer, occupancySaga} from './occupancy';
import {
  default as reportingReducer,
  invoiceReportingSaga,
  revenueReportingSaga,
  lookerRevenueReportingSaga
} from './reporting';
import {
  default as oneOffChargeReasonsReducer,
  oneOffChargeReasonsSaga
} from './oneOffChargeReasons';
import {commonSaga} from './common';
import {urlsSaga} from './urls';
import sortingReducer from './sorting';
import paginationReducer from './pagination';
import filtersReducer from './filters';
import {default as bookingSetsReducer, bookingSetsSaga} from './bookingSets';
import {
  default as notificationsReducer,
  selectUnsuccessfulBackendCalls,
  showToast as showToastAction
} from './notifications';
import {getBlockedActionToastObject} from './notifications/utils';
import pageReducer from './page';

const appReducer = combineReducers({
  router: routerReducer,
  form: formReducer,
  auth: authReducer,
  bookings: bookingsReducer,
  tenancy: tenancyReducer,
  allocations: allocationsReducer,
  files: filesReducer,
  modal: modalsReducer,
  locations: locationsReducer,
  rooms: roomsReducer,
  payments: paymentsReducer,
  countries: countriesReducer,
  frontDesk: frontDeskReducer,
  statusPage: statusPageReducer,
  users: usersReducer,
  teams: teamsReducer,
  notes: notesReducer,
  webhooks: webhooksReducer,
  quicksearch: quickSearchReducer,
  occupancy: occupancyReducer,
  reporting: reportingReducer,
  sorting: sortingReducer,
  pagination: paginationReducer,
  filters: filtersReducer,
  bookingSets: bookingSetsReducer,
  oneOffChargeReasons: oneOffChargeReasonsReducer,
  page: pageReducer,
  notifications: notificationsReducer
});

// TODO: move to /ducks/notifications/utils.tsx
const isActionConstantlyUnsuccessful = (state, action) => {
  const unsuccessfulBackendCalls = selectUnsuccessfulBackendCalls(state);

  const unsuccessfulBackendCall = _.head(
    unsuccessfulBackendCalls.filter(x => x.actionType == action.type)
  );

  if (!unsuccessfulBackendCall) {
    return false;
  }

  // If an action throws 500 more than 3 times - it's considered to be constantly unsuccessful
  return unsuccessfulBackendCall.occurrencesCounter >= 3;
};

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_REQUEST) {
    state = undefined;
  }

  // TODO: move this in a better suited place
  if (isActionConstantlyUnsuccessful(state, action)) {
    const toastObject = getBlockedActionToastObject();

    return appReducer(state, showToastAction(toastObject));
  }

  return appReducer(state, action);
};

// Use this in cases where you need an action but you don't want it to do anything.
export const noOpAction = () => ({
  type: 'NO_OP_ACTION'
});

export function* appSaga() {
  yield all(
    [
      loginFlow,
      forceInactivityLogoutFlow,
      userProfileRequestSaga,
      fetchBookingsSaga,
      bookingDetailSaga,
      fetchBookingsForBookingTrackerSaga,
      tenancyDetailSaga,
      allocationsSaga,
      filesSaga,
      locationListSaga,
      locationDetailSaga,
      roomsSaga,
      paymentsSaga,
      countriesSaga,
      agreementUsersSaga,
      frontDeskSaga,
      statusPageSaga,
      userListSaga,
      userDetailSaga,
      modalsSaga,
      teamsListSaga,
      teamsDetailSaga,
      notesSaga,
      webhooksSaga,
      quickSearchSaga,
      occupancySaga,
      invoiceReportingSaga,
      urlsSaga,
      commonSaga,
      revenueReportingSaga,
      lookerRevenueReportingSaga,
      bookingSetsSaga,
      oneOffChargeReasonsSaga
    ].map(fork)
  );
}

export default rootReducer;
